export default {"src":"/_next/static/media/twitter-x.3e079fde.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};